import { Dialog, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RejectEnrollmentIcon } from '../../icons';
import ArrowDownIcon from '../../icons/arrow-down';
import { getDatetimeText } from '../../utils/getDatetimeText';
import { Container, Detail, SelectWrapper, StyledButton, Title } from './style';
import useViewModel from './viewmodel';

type CancelEnrollmentDialogProps = {
  merchantName: string;
  referenceNumber: string;
  createdAt: string;
  open: boolean;
  cancelTypes: string[];
  onCancel?: () => void;
  onSubmit: (reason: string) => void;
};

const CancelEnrollmentDialog: FC<CancelEnrollmentDialogProps> = (props) => {
  const {
    merchantName,
    referenceNumber,
    createdAt,
    open,
    cancelTypes,
    onCancel,
    onSubmit,
  } = props;
  const { t } = useTranslation();

  const { reason, handleReasonTypeChange, handleSubmit } = useViewModel({
    cancelTypes,
    onSubmit,
  });

  return (
    <Dialog open={open}>
      <Container>
        <RejectEnrollmentIcon />
        <div>
          <Title>{t('dialog.cancel_enrollment')}</Title>
        </div>
        <Detail>
          <span>{t('recurring_payment_detail.biller')}</span>
          <span> {merchantName || '-'}</span>
        </Detail>
        <Detail>
          <span>{t('recurring_payment_detail.reference_number')}</span>
          <span style={{ wordBreak: 'break-all' }}>
            {referenceNumber || '-'}
          </span>
        </Detail>
        <Detail className="last-child">
          <span>{t('recurring_payment_detail.enrollment_date')}</span>
          <span>
            {createdAt ? getDatetimeText(createdAt, 'shortDate') : '-'}
          </span>
        </Detail>
        <SelectWrapper selected={Boolean(reason)}>
          <select
            defaultValue={cancelTypes[0]}
            onChange={handleReasonTypeChange}
          >
            <option disabled hidden value="none">
              {t('recurring_payment_detail.reason_cancel_type_placeholder')}
            </option>
            {cancelTypes.map((REASON_TYPE) => (
              <option key={REASON_TYPE} value={REASON_TYPE}>
                {REASON_TYPE}
              </option>
            ))}
          </select>
          <ArrowDownIcon className="arrow-down-icon" />
        </SelectWrapper>
        <Grid container justify="space-between" spacing={1}>
          <Grid item xs={6}>
            <StyledButton
              className="secondary"
              size="small"
              variant="outlined"
              onClick={onCancel}
            >
              {t('dialog.cancel')}
            </StyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              color="primary"
              disabled={!reason}
              size="small"
              variant="contained"
              onClick={handleSubmit}
            >
              {t('dialog.confirm')}
            </StyledButton>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default CancelEnrollmentDialog;
